import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { FiStar } from 'react-icons/fi';
import { API_BASE_URL as API_BASE } from '../services/api';

const Reviews = () => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.1 });
  const [reviews, setReviews] = useState([]);
  const [overall, setOverall] = useState({ score: '0.0', total: 0 });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API_BASE}/reviews/`)
      .then((r) => r.json())
      .then((data) => {
        const list = Array.isArray(data) ? data : data.results || [];
        const approved = list.filter((r) => r.is_approved !== false);
        const formatted = approved.slice(0, 6).map((r) => {
          const name = r.user_name || r.full_name || 'Foydalanuvchi';
          const initials = name.split(' ').map((w) => w[0]).slice(0, 2).join('').toUpperCase();
          return {
            id: r.id,
            name,
            initials,
            role: 'Foydalanuvchi',
            stars: r.rating || 5,
            text: r.comment || r.text || '',
          };
        });
        const avg = approved.length
          ? (approved.reduce((s, r) => s + (r.rating || 0), 0) / approved.length).toFixed(1)
          : '0.0';
        setReviews(formatted);
        setOverall({ score: avg, total: approved.length });
      })
      .catch(() => setReviews([]))
      .finally(() => setLoading(false));
  }, []);

  const container = {
    hidden: {},
    visible: { transition: { staggerChildren: 0.1 } },
  };

  const card = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5, ease: 'easeOut' } },
  };

  if (!loading && reviews.length === 0) {
    return null; // sharhlar yo'q bo'lsa, butun bo'limni ko'rsatmaymiz
  }

  return (
    <section className="reviews-section section-container" id="reviews" ref={ref}>
      <div className="reviews-header">
        <span className="section-tag">Sharhlar</span>
        <h2 className="section-title">
          Foydalanuvchilar <span className="gold-text">fikri</span>
        </h2>
        <p className="section-desc">
          OSTONA orqali o'z orzusidagi uyini topgan foydalanuvchilar.
        </p>
      </div>

      <div className="reviews-overall">
        <div className="reviews-overall-score">{overall.score}</div>
        <div className="reviews-overall-stars">
          {[1, 2, 3, 4, 5].map((s) => (
            <FiStar key={s} fill="currentColor" />
          ))}
        </div>
        <div className="reviews-overall-count">{overall.total} sharhlar asosida</div>
      </div>

      <motion.div
        className="reviews-grid"
        variants={container}
        initial="hidden"
        animate={inView ? 'visible' : 'hidden'}
      >
        {reviews.map((r) => (
          <motion.div className="review-card" key={r.id} variants={card}>
            <div className="review-stars">
              {Array.from({ length: r.stars }).map((_, j) => (
                <FiStar key={j} fill="currentColor" />
              ))}
            </div>
            <p className="review-text">"{r.text}"</p>
            <div className="review-author">
              <div className="review-avatar">{r.initials}</div>
              <div className="review-author-info">
                <h4>{r.name}</h4>
                <span>{r.role}</span>
              </div>
            </div>
          </motion.div>
        ))}
      </motion.div>
    </section>
  );
};

export default Reviews;
